var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayStore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "AraffhWwwEqZfgFEBZFoqa",
    x1: 18.102,
    x2: 25.297,
    y1: 3.244,
    y2: 34.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35ab4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#31a145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#288739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#237a33"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AraffhWwwEqZfgFEBZFoqa)",
    d: "M13.488,4.012C10.794,2.508,7.605,3.778,6.45,6.323L24.126,24l9.014-9.014L13.488,4.012z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "AraffhWwwEqZfgFEBZFoqb",
    x1: 19.158,
    x2: 21.194,
    y1: 23.862,
    y2: 66.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f14e5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#ea3d4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e12138"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AraffhWwwEqZfgFEBZFoqb)",
    d: "M33.14,33.014L24.126,24L6.45,41.677 c1.156,2.546,4.345,3.815,7.038,2.312L33.14,33.014z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "AraffhWwwEqZfgFEBZFoqc",
    x1: 32.943,
    x2: 36.541,
    y1: 14.899,
    y2: 43.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#ffc63f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb03a"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AraffhWwwEqZfgFEBZFoqc)",
    d: "M41.419,28.393 c1.72-0.96,2.58-2.676,2.581-4.393c-0.001-1.717-0.861-3.434-2.581-4.393l-8.279-4.621L24.126,24l9.014,9.014L41.419,28.393z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "AraffhWwwEqZfgFEBZFoqd",
    x1: 13.853,
    x2: 15.572,
    y1: 5.901,
    y2: 42.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#0090e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0065a0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AraffhWwwEqZfgFEBZFoqd)",
    d: "M6.45,6.323C6.168,6.948,6,7.652,6,8.408 v31.179c0,0.761,0.164,1.463,0.45,2.09l17.674-17.68L6.45,6.323z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayStore);
export default __webpack_public_path__ + "static/media/google-play-store.7660dcd6b3b40be498aec2dcd032a4cf.svg";
export { ForwardRef as ReactComponent };